import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertTriangle, FiAlertCircle } = FiIcons;

const AlertBanner = ({ alerts }) => {
  if (!alerts || (alerts.warningCount === 0 && alerts.watchCount === 0)) {
    return null;
  }

  const getBannerConfig = () => {
    if (alerts.warningCount > 0) {
      return {
        type: 'warning',
        icon: FiAlertTriangle,
        bgColor: 'bg-red-600',
        textColor: 'text-white',
        message: `${alerts.warningCount} Active Warning${alerts.warningCount > 1 ? 's' : ''}`,
        description: 'Critical events detected. Please take immediate precautions.'
      };
    }
    if (alerts.watchCount > 0) {
      return {
        type: 'watch',
        icon: FiAlertCircle,
        bgColor: 'bg-amber-500',
        textColor: 'text-white',
        message: `${alerts.watchCount} Active Watch${alerts.watchCount > 1 ? 'es' : ''}`,
        description: 'Conditions are favorable for hazardous events. Monitor official sources.'
      };
    }
    return null;
  };

  const config = getBannerConfig();
  if (!config) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${config.bgColor} ${config.textColor} px-4 py-3 shadow-lg`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <SafeIcon icon={config.icon} className="text-xl animate-pulse" />
          <div>
            <h3 className="font-semibold text-sm">{config.message}</h3>
            <p className="text-xs opacity-90">{config.description}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AlertBanner;